import { call, put, takeEvery } from "redux-saga/effects";
// actions
import {
  AssignCustomerAccountManagerSuccess,
  AssignCustomerAccountManagerFailure,
} from "../../actions/Customers/AssignCustomerAccountManager";
// constant
import { ASSIGN_CUSTOMER_ACCOUNT_MANAGER } from "../../constants/Customers/AssignCustomerAccountManager";
// request type
import postRequest from "../../../util/APIHelperPost";
// base url
import { baseUrl } from "../../../util/APIBaseUrl";

export const fetchAssignCustomerAccountManagerRequest = async (actions) => {
  const body = JSON.stringify({
    accountManagerId: actions.payload.accountManagerId,
  });

  return await postRequest(`${baseUrl}/customer/${actions.payload.customerId}/assign-am`, body)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchAssignCustomerAccountManager(params) {
  try {
    const response = yield call(fetchAssignCustomerAccountManagerRequest, params);

    yield put(AssignCustomerAccountManagerSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(AssignCustomerAccountManagerFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(ASSIGN_CUSTOMER_ACCOUNT_MANAGER, fetchAssignCustomerAccountManager);
}
